export default __webpack_public_path__ + "static/media/p7-10.61472c08.png";